import AppLinkButton from '../app/AppLinkButton';
import { BASE_IMG_URL } from 'const/ConstBase';

import './PaymentBody.scss';

interface Props {
    backgroundImageUrl: string;
    description: string;
    buttonText: string;
    link: string;
}

const PaymentBody = ({
    backgroundImageUrl,
    description,
    buttonText,
    link,
}: Props) => {
    return (
        <div
            className='payment-body'
            style={{
                backgroundImage: `url(${BASE_IMG_URL}${backgroundImageUrl})`,
            }}
        >
            <p className='desc'>{description}</p>

            <AppLinkButton
                buttonClassName='redirect-button'
                buttonText={buttonText}
                link={link}
                isBorderColor={false}
                isHover={false}
            />
        </div>
    );
};

export default PaymentBody;
